export default function parseResponse(response) {
    return response
        .arrayBuffer()
        .then((arrayBuffer) => new Uint8Array(arrayBuffer));
}
